import React from 'react';
import type {
  LlmModelProviderLabel,
  LlmModelRegion,
} from 'constant/llm-model';

export enum ModelTypes {
  VISION,
  NO_VISION,
}

export interface IModel {
  id: string;
  name: string;
  description: string;
  icon: React.ReactNode;
  modelType: ModelTypes;
  isThinkingModel: boolean;
  isDefaultModel: boolean;
  order: number;
  hasDynamicThinking?: boolean;
  isHarmonicModel?: boolean;
  region?: LlmModelRegion;
  providerLabel?: LlmModelProviderLabel;
  /** Switched off for this person right now, e.g. a category's share of the day is used. */
  paused?: boolean;
  pausedReason?: string;
  /** Runs on the organization's top-up credits, though the plan alone would not allow it. */
  viaTopUp?: boolean;
  /** One of the tenant's own models, picked by id rather than by name. */
  isCustom?: boolean;
}

interface SupportedExtensions {
  image: string[];
  document: string[];
}

export const modelSupportedExtensionsMap: Record<ModelTypes, SupportedExtensions> = {
  [ModelTypes.VISION]: {
    image: ['.jpg', '.jpeg', '.png', '.heic'],
    document: ['.pdf', '.txt', '.docx', '.csv', '.xlsx', '.pptx', '.json', '.html', '.vsdx'],
  },
  [ModelTypes.NO_VISION]: {
    image: [],
    document: ['.pdf', '.txt', '.docx', '.csv', '.xlsx', '.pptx', '.json', '.html', '.vsdx'],
  },
};

export const allSupportedImageExtensions = [
  ...modelSupportedExtensionsMap[ModelTypes.VISION].image,
  ...modelSupportedExtensionsMap[ModelTypes.NO_VISION].image,
];

export const VECTORIZE_EXCLUDE_EXTENSIONS = ['xlsx', 'csv', 'json', 'vsdx'];
  
export interface TranscribeAudioToTextResponse {
  text: string
  language: string
  languageConfidence: number
  duration: number
}
